export const BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
  "4k": 2560,
};
